import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";
import { api, setToken } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const saved = sessionStorage.getItem("aria_oauth_state");
    if (!code) { navigate("/login", { replace: true }); return; }
    if (saved && state && saved !== state) { navigate("/login?error=state", { replace: true }); return; }
    const redirectUri = window.location.origin + "/auth/google";
    api.authGoogle(code, redirectUri)
      .then((d) => { setToken(d.token); sessionStorage.removeItem("aria_oauth_state"); window.location.href = "/"; })
      .catch((e) => {
        if (e?.response?.status === 403) navigate("/login?error=unauthorized", { replace: true });
        else setError(e?.response?.data?.detail || "Sign-in failed. Please try again.");
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background px-6 text-center">
      <div className="h-11 w-11 rounded-2xl bg-slate-900 flex items-center justify-center aria-thinking">
        <Sparkle weight="fill" className="text-white" size={24} />
      </div>
      {error ? (
        <>
          <p className="text-sm text-rose-700" data-testid="auth-error">{error}</p>
          <button onClick={() => navigate("/login", { replace: true })} className="text-sm text-slate-600 underline">Back to sign in</button>
        </>
      ) : (
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      )}
    </div>
  );
}
